/**
 * Premium Theme JS — Safe Shoe Wash
 * Scroll-reveal animations, micro-interactions
 */

(function () {
  'use strict';

  /* ---------------------------------------------------------------
     SCROLL REVEAL  (IntersectionObserver)
     Targets elements with class .p-reveal or .p-reveal-scale
     Added via data-delay="1-6" for staggered entrance
  --------------------------------------------------------------- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.p-reveal, .p-reveal-scale').forEach(function (el) {
        el.classList.add('p-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('p-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.p-reveal, .p-reveal-scale').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     HEADER SHADOW ON SCROLL
     Adds .is-scrolled to the header-group when page is scrolled
  --------------------------------------------------------------- */
  function initHeaderScroll() {
    var headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    function onScroll() {
      if (window.scrollY > 8) {
        headerGroup.classList.add('is-scrolled');
      } else {
        headerGroup.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* ---------------------------------------------------------------
     COUNTER ANIMATION
     Targets .p-stat__number elements — counts up when visible
  --------------------------------------------------------------- */
  function animateCounter(el, target, duration) {
    var start = 0;
    var startTime = null;
    var suffix = el.dataset.suffix || '';
    var prefix = el.dataset.prefix || '';

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(start + (target - start) * eased);
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    if (!('IntersectionObserver' in window)) return;

    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var target = parseInt(el.dataset.count, 10);
            if (!isNaN(target)) {
              animateCounter(el, target, 1600);
            }
            counterObserver.unobserve(el);
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('.p-stat__number[data-count]').forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     SMOOTH ANCHOR SCROLL
     Enhances native scroll-behavior for internal anchor links
  --------------------------------------------------------------- */
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var id = this.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var offset = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0',
          10
        );
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ---------------------------------------------------------------
     CART DRAWER TOTAL PULSE
     Briefly pulses the cart badge when count changes
  --------------------------------------------------------------- */
  function initCartBadgePulse() {
    var badge = document.querySelector('[data-cart-bubble], .cart-bubble');
    if (!badge) return;

    var lastCount = badge.textContent;

    var mo = new MutationObserver(function () {
      var newCount = badge.textContent;
      if (newCount !== lastCount) {
        lastCount = newCount;
        badge.classList.remove('p-pulse');
        // Force reflow
        void badge.offsetWidth;
        badge.classList.add('p-pulse');
        badge.addEventListener('animationend', function () {
          badge.classList.remove('p-pulse');
        }, { once: true });
      }
    });

    mo.observe(badge, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------
     INIT
  --------------------------------------------------------------- */
  function init() {
    initScrollReveal();
    initHeaderScroll();
    initCounters();
    initSmoothAnchors();
    initCartBadgePulse();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run scroll reveal after Shopify section renders (theme editor)
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initCounters();
  });

})();
